/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * One card on a dashboard: the saved widget it links to and where it sits on the 12-column grid. The same widget may be placed more than once.
 */
export type DashboardPlacement = {
  /**
   * Height in rows
   */
  h: number;
  /**
   * Stable across layout edits, so the grid keeps the card's identity
   */
  id: string;
  /**
   * Width in columns
   */
  w: number;
  widgetId: string;
  /**
   * Column the card starts at, from 0
   */
  x: number;
  /**
   * Row the card starts at, from 0
   */
  y: number;
};

/** @internal */
export const DashboardPlacement$inboundSchema: z.ZodMiniType<
  DashboardPlacement,
  unknown
> = z.pipe(
  z.object({
    h: z.int(),
    id: z.string(),
    w: z.int(),
    widget_id: z.string(),
    x: z.int(),
    y: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "widget_id": "widgetId",
    });
  }),
);

export function dashboardPlacementFromJSON(
  jsonString: string,
): SafeParseResult<DashboardPlacement, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DashboardPlacement$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DashboardPlacement' from JSON`,
  );
}
